<vn-header-bar
    (onClose)="localProductMenuService.toggle()"
    [class]="config.headerBarCssClass"
    [closeButtonTextCssClass]="config.closeButtonTextCssClass"
    [closeButtonText]="config.showCloseButtonAsText ? item.resources['close-button-text'] : ''"
    [showBack]="false"
    [title]="title"
    [useLogoHeader]="headerLogoItem">
    <ng-content ngProjectAs="[header-bar-logo-slot]">
        @for (child of item.children; track trackByProp($index, child)) {
            <ng-container *vnDynamicComponent="getItemComponent(child.type); attr: { item: child }" />
        }
    </ng-content>
</vn-header-bar>
